<template>
  <div>
    <uni-popup ref="usage" type="bottom" @change="onPopupChange">
      <uni-card title="处方用法" :is-full="true" :note="true">
        <!-- 宁城县中医院 -->
        <div v-if="['28770'].includes(hospitalID)" class="drug_wrap">
          <uni-card :is-full="true">
            <div class="has-required">
              <div class="required-star">*</div>
              <ms-select-dicNew
                code="chinese_drug_usage"
                :title="'药品用法：'"
                :right-text="form.chineseDrugUsage"
                :uniListTop="true"
                @changeDicValue="changeChineseDrugUsage"
              />
            </div>
            <div class="input_wrap package">
              <span class="input_title">包装量：</span>
              <div class="input_row">
                <input
                  v-model="form.packageNumber"
                  type="number"
                  placeholder="请输入"
                  placeholder-style="color:#CECECE;font-size:.597333rem"
                  placeholder-class="input-placeholder"
                  class="input_con"
                />
              </div>
            </div>
            <!-- 频率 -->
            <div class="has-required">
              <div class="required-star">*</div>
              <ms-frequency v-model="form.herbFrequence" />
            </div>
            <div class="input_wrap package">
              <span class="input_title">每剂</span>
              <div class="input_row alignr">
                <input
                  v-model="form.herbPerDoseTimes"
                  type="number"
                  placeholder="请输入"
                  placeholder-style="color:#CECECE;font-size:.597333rem"
                  placeholder-class="input-placeholder"
                  class="input_con"
                />
                次
              </div>
            </div>
          </uni-card>
        </div>
        <!-- 其他医院 -->
        <div v-else class="drug_wrap">
          <!-- <div class="drug_wrap"> -->
          <uni-card :is-full="true">
            <div class="input_wrap" @click="selectTime">
              <span class="input_title">用药次数：</span>
              <uni-popup ref="timePopup" type="bottom" @change="changePop">
                <div class="btn_row">
                  <div class="confirm_btn" @click="confirmDesc">
                    <span>确认</span>
                  </div>
                </div>
                <picker-view class="picker-view" @change="changeTimes">
                  <picker-view-column>
                    <div v-for="item in arr" :key="item.code" class="item">
                      {{ item.value }}
                    </div>
                  </picker-view-column>
                </picker-view>
              </uni-popup>
              <div class="show_time">
                <span>{{ form.times }}</span>
                <span class="unit">次</span>
              </div>
            </div>
            <ms-select-dicNew
              :code="'chinese_drug_usage'"
              :title="'药品用法：'"
              :right-text="form.chineseDrugUsage"
              :uniListTop="true"
              @changeDicValue="changeChineseDrugUsage"
            ></ms-select-dicNew>
            <div class="input_wrap package">
              <span class="input_title">包装量：</span>
              <div class="input_row">
                <input
                  v-model="form.packageNumber"
                  type="number"
                  placeholder="请输入"
                  placeholder-style="color:#CECECE;font-size:.597333rem"
                  placeholder-class="input-placeholder"
                  class="input_con"
                />
              </div>
            </div>
            <div class="content">
              <div class="uni-textarea">
                <span class="input_title">处方说明：</span>
                <textarea
                  v-model="form.prescripDesc"
                  placeholder="请输入处方说明"
                  placeholder-style="color:#CECECE;font-size:.64rem"
                  placeholder-class="textarea-placeholder"
                  :show-confirm-bar="false"
                ></textarea>
              </div>
            </div>
          </uni-card>
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="confirmUpdateUsage">
            <span class="btn">确定</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getKeyValue } from '@/views/funcPuzzle/utils/util.js'
import MsSelectDicNew from '@/views/funcPuzzle/components/ms-select-dicNew/ms-select-dicNew.vue'
import msFrequency from './ms-frequency.vue'

export default {
  components: {
    msFrequency,
    'ms-select-dicNew': MsSelectDicNew
  },
  props: {
    modelValue: {
      type: [Object, Boolean],
      default() {
        return null
      }
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    }
  },
  data() {
    return {
      arr: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' }
      ],
      form: {
        herbFrequence: '', // 频率 // 只有宁城中心医院使用
        herbPerDoseTimes: '', // 每剂次数 // 只有宁城中心医院使用
        times: '',
        chineseDrugUsage: '',
        packageNumber: '',
        prescripDesc: ''
      }
    }
  },
  computed: {
    hospitalID() {
      return this.hospitalID
    }
  },
  watch: {
    modelValue: {
      handler(n) {
        if (n) {
          this.form = Object.assign(this.form, n)
          this.open()
          this.arr = this.getKeyValue('chinese_drug_frequence_his')

          this.form.chineseDrugUsage = ['28770'].includes(this.hospitalID)
            ? this.getKeyValue('chinese_drug_usage')[0].code
            : ''
        }
      },
      immediate: true
    }
  },
  methods: {
    getKeyValue,
    onPopupChange({ show }) {
      // 关闭用药处方的时候更新父组件v-model绑定的值，解决下次不能打开弹框
      !show && this.$emit('update:modelValue', null)
    },
    // 修改用药次数-------开始
    changePop(val) {
      // 打开用药次数设置默认值
      if (val.show && !this.form.times) {
        this.changeTimes({ detail: { value: [this.arr[0].value] } })
      }
    },
    selectTime() {
      // 打开用药次数弹框
      this.$refs.timePopup.open()
    },
    confirmDesc() {
      // 关闭用药次数弹框
      this.$refs.timePopup.close()
    },
    changeTimes(e) {
      // 更新用药次数的值
      this.form.times = e.detail.value[0]
    },
    // 修改用药次数-------结束
    open() {
      // 打开处方用法弹框
      this.$refs.usage && this.$refs.usage.open()
    },
    close(data) {
      // 关闭处方用法弹框, 点确认就更新数据,否则不更新数据
      this.$refs.usage && this.$refs.usage.close()
      this.$emit('closeUsage', data)
    },
    // 修改药品用法----开始
    showChineseDrugUsage() {
      // 打开药品用法弹框
      this.$refs.chineseDrugUsage.open()
    },
    changeChineseDrugUsage(val) {
      // 更新药品用法的值
      this.form.chineseDrugUsage = val
    },
    // 修改药品用法----结束
    confirmUpdateUsage() {
      // 如果医院是宁城中心医院，需要校验用法和频率
      if (this.hospitalID === '28770') {
        console.log('this.form', this.form, 28770)
        if (!this.form.chineseDrugUsage) {
          uni.showToast({
            title: '请选择药品用法',
            icon: 'none'
          })
          return
        }
        if (!this.form.herbFrequence) {
          uni.showToast({
            title: '请选择频率',
            icon: 'none'
          })
          return
        }
      }
      // 处方用法修改完成
      this.close(this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.drug_wrap {
  height: 19.2rem;
  overflow-y: scroll;
  overflow-x: hidden;
  .content {
    color: #888;
    line-height: 1.75;
    font-size: 0.597333rem;
    border-top: 0.021333rem solid #ececec;
    padding-left: 0.682667rem;
    .uni-textarea {
      display: flex;
      flex-direction: column;
      padding-top: 0.682667rem;
      .input_title {
        width: 4.266667rem;
        font-size: 0.597333rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 0.853333rem;
        margin-bottom: 0.298667rem;
      }
    }
  }
  .input_wrap,
  .package {
    display: flex;
    padding: 0 0.682667rem 0 0.682667rem;
    align-items: center;
    justify-content: space-between;
    height: 2.005333rem;
    .show_time {
      width: 2.133333rem;
      text-align: end;
      .unit {
        padding-left: 0.085333rem;
      }
    }

    .input_row {
      display: flex;
      width: 3.626667rem;
      height: 100%;
      align-items: center;
      .input_con {
        text-align: right;
      }
      .unit {
        margin-left: 0.213333rem;
      }
      &.alignr {
        justify-content: flex-end;
      }
    }
  }
  .package {
    border-top: 0.021333rem solid #ececec;
  }
}
.btn_row {
  display: flex;
  width: 100%;
  background-color: #fff;
  justify-content: space-between;
  .delete_btn,
  .confirm_btn {
    height: 1.706667rem;
    background-color: #fff;
    padding: 0 0.853333rem;
    line-height: 2.56rem;
    color: #2772ff;
  }
}
.footer-box {
  text-align: center;
  width: 14.634667rem;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  font-weight: 500;
  .btn {
    color: #fff;
  }
}
::v-deep .picker-view {
  height: 10.666667rem;
  background: #fff;
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 1.066667rem;
  }
}
.has-required {
  position: relative;

  .required-star {
    color: #e63746;
    font-size: 0.682667rem;
    position: absolute;
    left: 0.277333rem;
    top: 0.789333rem;
    z-index: 1;
  }
}
</style>
